import "./style.scss";

import Plus from "assets/img/svg/plus";
import type { MouseEventHandler } from "react";

interface AddChannelButtonProps {
    label: string;
    onClick: MouseEventHandler<HTMLButtonElement>;
    /** Horizontal alignment of the link-style button within its row. */
    align?: "start" | "end";
    className?: string;
}

/**
 * Link-style control to add or select a channel (same pattern as title price channels step).
 */
const AddChannelButton = ({ label, onClick, align = "end", className }: AddChannelButtonProps) => {
    return (
        <div className={`add-channel add-channel--${align}${className ? ` ${className}` : ""}`}>
            <button type="button" className="add-channel-button" onClick={onClick}>
                <span className="add-channel-button-icon" aria-hidden>
                    <Plus width="18" height="18" />
                </span>
                {label}
            </button>
        </div>
    );
};

export default AddChannelButton;
